import styled, { css } from 'styled-components';

import {
  motionTimeS,
  scale005,
  scale050,
  scale120,
  spaceL,
  spaceS,
  xdlColorBorderSoft,
  xdlColorTextSecondary,
} from '@xing-com/tokens';

export const socialCountersTransitionName = 'counters-animation';
export const socialCountersAnimationDuration = motionTimeS;

// *** Base ***
const baseSocialCountersWrapper = css`
  align-items: center;
  border-bottom: solid ${scale005} ${xdlColorBorderSoft};
  display: flex;
  flex-direction: row;
  height: ${scale120};
  opacity: 0;
  padding-bottom: ${spaceS};
  position: relative;
  transition-property: all;
  width: 100%;

  & button,
  & a {
    color: ${xdlColorTextSecondary};

    &:hover {
      color: ${xdlColorTextSecondary};
    }
  }

  /* Social Counters Animation */
  &.${socialCountersTransitionName}-enter {
    transition-delay: 40ms;
    transition-duration: 10ms;
    top: -15px;
    opacity: 0;
  }

  &.${socialCountersTransitionName}-enter-active {
    opacity: 0.5;
    transition-duration: 50ms;
    top: -${scale050};
  }

  &.${socialCountersTransitionName}-enter-done {
    transition-duration: 50ms;
    opacity: 1;
    top: 0;
  }

  &.${socialCountersTransitionName}-exit {
    transition-duration: 50ms;
    opacity: 0.66;
    top: 1;
  }

  &.${socialCountersTransitionName}-exit-active {
    transition-duration: 50ms;
    opacity: 0.33;
    top: -5px;
  }

  &.${socialCountersTransitionName}-exit-done {
    transition-duration: 50ms;
    opacity: 0;
    top: -${scale050};
  }
`;

const baseSocialCounters = css`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: left;
`;

// *** Components ***
const SocialCountersWrapper = styled.div`
  ${baseSocialCountersWrapper}
`;

const SocialCounters = styled.div<{ $compact: boolean }>`
  ${baseSocialCounters}
  ${({ $compact }) =>
    $compact &&
    css`
      & > * {
        margin-right: ${spaceL};
      }
    `}
`;

export const Styled = {
  SocialCountersWrapper,
  SocialCounters,
};
